export default __webpack_public_path__ + "static/media/rules_icon.a4109847.svg";